import { Routes } from '@core/constants/routes.ts';
import { ParamRoutes } from '@core/models/router.model';

export interface MergeRoutesConfig {
  params?: ParamRoutes;
  omitInitialHash?: boolean;
  omitParams?: boolean;
}

export const mergeRoutes = (
  paths: Routes | Routes[],
  config?: MergeRoutesConfig
) => {
  const initialPath = config?.omitInitialHash ? '' : '/';
  if (Array.isArray(paths)) {
    return paths.reduce((prev, curr, idx) => {
      let currentPath = curr;
      if (curr[0] === ':' && !config?.omitParams) {
        try {
          if (config?.params) {
            const paramName = curr.slice(1);
            currentPath = config.params[paramName] as Routes;
            if (!currentPath) {
              throw new Error("Route param doesn't exist on param object");
            }
          } else {
            throw new Error(
              'Exist one or more route params and params object is empty. ' +
                JSON.stringify(paths)
            );
          }
        } catch (e) {
          console.error(e);
          currentPath = curr;
        }
      }
      return `${prev}${currentPath}${idx + 1 < paths.length ? '/' : ''}`;
    }, initialPath);
  }
  return `${initialPath}${paths}`;
};
